import { useCookies } from "react-cookie";
import { useNavigate } from "react-router";
import { useAuth } from "../components/AuthProvider.tsx";

interface Props {
  page: string
}

const MenuComponent = ({ page }: Props) => {
  const { authorization, SetAuthorization } = useAuth();
  const [cookies, SetCookie, RemoveCookie] = useCookies(["Token"]);
  const navigate = useNavigate();

  const Logout = () => {
    RemoveCookie("Token", { path: "/" });
    SetAuthorization(null);
  }  

  return (
    <>
      <header>
        <a href="#main" className="skip">Skip to main content</a>
        <div className="container">
          <div className="logo"><a href="/"><img src="/images/logo.jpg" alt="Rural Community Immigration Pilot Logo" /></a></div>
          <nav role="navigation" aria-label="Main Menu">
            {authorization.IsAdministrator ?
            <ul>
              <li><a onClick={() => navigate("/admin/profiles")}>Profiles</a></li>
              <li><a onClick={() => navigate("/admin/applications")}>Applications</a></li>
              <li><a onClick={() => navigate("/admin/search")}>Search</a></li>
              <li><a onClick={() => navigate("/admin/support")}>Support</a></li>
              <li><a onClick={Logout}>Logout</a></li>
            </ul>:
            <ul>
              <li><a onClick={() => navigate("/profile")}>Profile</a></li>
              {authorization.IsComplete && <li><a onClick={() => navigate("/applications")}>Applications</a></li>}
              <li><a onClick={() => navigate("/support")}>Support</a></li>
              <li><a onClick={Logout}>Logout</a></li>
            </ul>}
          </nav>
          <h1>{page}</h1>
        </div>
      </header>
      <div id="hamburgericonmenuwrapper">
        <div id="hamburgerui">
          <ul>
            <li>&nbsp;</li>
            <li><a href="#" aria-label="Open the menu" className="toggleButton"><span id="navtoggler"></span></a></li>
          </ul>
        </div>
        <div className="menu-mobile-menu-container">
          <div className="logo"><a href="/"><img src="/images/logo.jpg" alt="Rural Community Immigration Pilot Logo" /></a></div>
          <nav role="navigation" aria-label="Main Menu">
            {authorization.IsAdministrator ?
              <ul>
                <li><a onClick={() => navigate("/admin/profiles")}>Profiles</a></li>
                <li><a onClick={() => navigate("/admin/applications")}>Applications</a></li>
                <li><a onClick={() => navigate("/admin/search")}>Search</a></li>
                <li><a onClick={() => navigate("/admin/support")}>Support</a></li>
                <li><a onClick={Logout}>Logout</a></li>
              </ul>:
              <ul>
                <li><a onClick={() => navigate("/profile")}>Profile</a></li>
                {authorization.IsComplete && <li><a onClick={() => navigate("/applications")}>Applications</a></li>}
                <li><a onClick={() => navigate("/support")}>Support</a></li>
                <li><a onClick={Logout}>Logout</a></li>
              </ul>
            }
          </nav>
        </div>
      </div>
    </>
  )
};

export default MenuComponent;